import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { BoardsStoreEffects } from './effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('boards', reducer),
    EffectsModule.forFeature([BoardsStoreEffects]),
  ],
  providers: [],
})
export class BoardsStoreModule {}
